{
    "name": "Brazilian Starfish Pepper",
    "binomial_name": "Capsicum baccatum",
    "common_names": [],
    "description": "Brazilian Starfish is a Capsicum baccatum cultivar hot pepper. It produces squat, 2cm wide, starfish-shaped fruits that have a rating of 10,000 to 30,000 Scoville units (close to or hotter than a serrano). The plant is a late, but prolific, producer and has an elegant weeping, vine-like growing habit. The peppers are green when young and turn bright red as they mature. They have a sweet, juicy, fruity taste and can be eaten fresh, dried, or pickled.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Direct seed indoors, transplant seedlings after hardening off.",
    "spread": 0,
    "row_spacing": 50,
    "height": 0,
    "growing_degree_days": 0,
    "companions": [],
    "image": "",
    "icon": "/crops/icons/brazilian-starfish-pepper.avif"
}